import router from "@/router";
import { useMainStore } from "@/store";
import * as jose from "jose";
import { apiConnection } from "@/services/api-connection";
import { notificationManager } from "@/services/notification-manager";

class LoginManager {
  interval = null;
  length = 5000;
  loginAttempt = 0;
  maxAttempt = 40;

  watchLogin() {
    const linked = localStorage.getItem("aixam-linked");
    const uid = localStorage.getItem("aixam-device-uid");
    if (linked === "1" && uid) {
      this.ping().then((res) => {
        if (res && res.code_client) {
          localStorage.setItem("aixam-linked", 1);
          this.redirect();
        }
        if (res) {
          useMainStore().setJpoUrl(res.jpo_url);
          localStorage.setItem("aixam-jpo-url", res.jpo_url);
        }
      });
    } else {
      this.getCode().then(() => {
        this.setLoginPing();
      });
    }
  }

  setLoginPing() {
    if (!this.interval) {
      this.interval = setInterval(this.callbackLogin, this.length);
    }
  }

  async call(path, method = "GET", params = {}) {
    const store = useMainStore();
    return new Promise((resolve) => {
      this.getJwt().then((token) => {
        const url =
          process.env.VUE_APP_API_PORTAIL +
          path +
          (method === "GET" ? "?uuid=" + store.uid : "");
        apiConnection.fetchApi(method, url, params, token).then((data) => {
          useMainStore().setCode(data.code);
          resolve(data);
        });
      });
    });
  }

  async getCode() {
    const store = useMainStore();
    const url =
      process.env.VUE_APP_API_PORTAIL +
      "/api/tv/associationCode?uuid=" +
      store.uid;
    return apiConnection.fetchApi("GET", url, {}).then((data) => {
      useMainStore().setCode(data.code);
    });
  }

  async ping() {
    return this.call("/api/tv/ping").then((data) => data);
  }

  token() {
    const store = useMainStore();
    const url =
      process.env.VUE_APP_API_PORTAIL + "/api/tv/token?uuid=" + store.uid;
    return apiConnection.fetchApi("GET", url, {}).then((data) => {
      if (data && data.api_private_key && data.api_login) {
        if (data.configurator_url) {
          localStorage.setItem("aixam-configurator-url", data.configurator_url);
        }
        localStorage.setItem("aixam-private-key", data.api_private_key);
        localStorage.setItem("aixam-login", data.api_login);
        localStorage.setItem("aixam-linked", 1);
        this.stopPing();
        this.redirect();
      }
    });
  }

  async updateAction(actionId) {
    const store = useMainStore();
    return this.call("/api/tv/deviceAction", "POST", {
      uuid: store.uid,
      action_id: actionId,
    }).then((data) => data);
  }

  stopPing() {
    if (this.interval) {
      clearTimeout(this.interval);
      this.interval = null;
    }
  }

  callbackLogin = () => {
    this.loginAttempt++;
    if (this.loginAttempt >= this.maxAttempt) {
      this.stopPing();
      this.alertLogin();
    }
    this.token();
  };

  alertLogin() {
    notificationManager
      .showAlert(
        "Connexion / Login",
        "Code : " + useMainStore().code,
        false,
        false,
        "Associer ma TV / Link my TV",
      )
      .then((res) => {
        if (res.isConfirmed) {
          this.token().then(() => {
            if (
              !localStorage.getItem("aixam-login") &&
              !localStorage.getItem("aixam-private-key")
            ) {
              this.alertLogin();
            }
          });
        } else {
          this.alertLogin();
        }
      });
  }

  redirect() {
    router.push({ name: "Home" });
  }

  async getJwt() {
    const pkcs8 = localStorage.getItem("aixam-private-key");
    const issuer = localStorage.getItem("aixam-login");

    const alg = "RS256";
    const privateKey = await jose.importPKCS8(pkcs8, alg);

    return await new jose.SignJWT({})
      .setProtectedHeader({ alg })
      .setIssuedAt()
      .setIssuer(issuer)
      .setExpirationTime("2h")
      .setProtectedHeader({ alg: alg, typ: "JWS" })
      .sign(privateKey);
  }
}

export const loginManager = new LoginManager();
